import type { NotifyPort } from '@/features/messages/domain/notify'
import type { CreateStepInput, CreateTransitionInput, Step, UpdateStepInput, WorkflowPort } from '../domain/workflow'

const createStep = async (
	port: WorkflowPort,
	input: CreateStepInput,
	notify: NotifyPort,
): Promise<Step | null> => {
	try {
		const step = await port.createStep(input)

		if (!input.isInbox) {
			const userTransitions: CreateTransitionInput[] = (input.transitions ?? []).map(t => ({
				...t,
				fromStepId: step.id,
				isDefault: false,
			}))

			const defaultOk: CreateTransitionInput = {
				fromStepId: step.id,
				label: 'Ok',
				trigger: 'manual',
				target: input.defaultTarget ?? { kind: 'none' },
				isDefault: true,
			}

			const allTransitions = [defaultOk, ...userTransitions]
			await Promise.all(allTransitions.map(t => port.createTransition(t)))

			if (input.inboxTransitionId) {
				await port.updateTransition({
					id: input.inboxTransitionId,
					label: 'Atribuir',
					trigger: 'manual',
					target: { kind: 'step', stepId: step.id },
				})
			}
		}

		notify.success('workflow.stepCreated')
		return step
	} catch {
		notify.error('workflow.stepCreateFailed')
		return null
	}
}

const updateStep = async (
	port: WorkflowPort,
	input: UpdateStepInput,
	notify: NotifyPort,
): Promise<Step | null> => {
	try {
		const step = await port.updateStep(input)
		notify.success('workflow.stepUpdated')
		return step
	} catch {
		notify.error('workflow.stepUpdateFailed')
		return null
	}
}

const deleteStep = async (
	port: WorkflowPort,
	id: string,
	notify: NotifyPort,
): Promise<boolean> => {
	try {
		await port.deleteStep(id)
		notify.success('workflow.stepDeleted')
		return true
	} catch {
		notify.error('workflow.stepDeleteFailed')
		return false
	}
}

export { createStep, updateStep, deleteStep }
